import React ,{useState,forwardRef} from 'react';
import './Input.css';
import Map from "../../../views/Map.jsx";
import  MultiSelect from "react-multi-select-component";
import { useTranslation } from 'react-i18next';
import swal from 'sweetalert';
import  Select  from 'react-select'
import 'assets/css/custom.css';
import moment from 'moment';
import CustomSwitch from '../../CustomSwitch/CustomSwitch';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const InputField = ( props,ref ) => {
    const { t, i18n } = useTranslation();
    let [tempImg, setTempImg] = useState();
    const customer_id = cookies.get('customer_id');
    let inputElement = null;
    let selectiveInputField = () => {
        return (
        <div>
            <select
             className="form-control"
             value={props.value}
             disabled={(props.elementConfig.readonly || props.elementConfig.disabled) ? true : false}
             onChange={props.changed}
             options= {props.elementConfig.options}>
                 {props.elementConfig.options.map((option) => {
                    let values = Object.values(props.elementConfig.options)
                    if(values.every((value) => value.hasOwnProperty('displayValue'))){
                    return <option key={option.value} value={props.title === 'Pairing' ? option.displayValue : option.value}>
                         {(option.displayValue !== null && option.displayValue.toString().toLowerCase()==='please select')? t(option.displayValue):(props.title === "Vendor Serial Number")?t(option.displayValue):option.displayValue} 
                     </option>
                 }
            })}
                 </select>
                 <span>{ (props.isValidate.required === true) ? 
                props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) :
                null}</span>
       </div>
        )
   }

   const filterOptions = (options, filter) => {
    if (!filter) {
      return options;
    }
    const filteredOptions = options.filter((obj => {
        if(obj.hasOwnProperty('label') && obj['label'] !== null){
        return obj.label.toLowerCase().includes(filter.toLowerCase())
        }
    }))
    return filteredOptions;
  };

   let renderView = () => {
    return props.visible && props.id == 'component_type' ? selectiveInputField()
    : props.show && props.id == 'components' ? selectiveInputField()
    : selectiveInputField();
   }
    window.pressed = function(e) {
        if(props.hasOwnProperty("imagePath")){
        if(e.target.files[0].type === "image/png"){
            let reader = new FileReader();
            let file = e.target.files[0];
            let sizeInMB = ((file.size) / (1024*1024)).toFixed(2);
            if(sizeInMB > 1)
              return swal({
                title:`${t("alerts.upload_image")}`,
                icon:"warning",
                button:`${t("alerts.ok")}`
                })
                reader.readAsDataURL(file);
            setTempImg(URL.createObjectURL(e.target.files[0]));
            let a = document.getElementById('files');
            let b = document.getElementById('fileLabel')
            if (a.value == "") {
              b.innerHTML = "Choose file";
            } else {
              let theSplit = a.value.split('\\');
              b.innerHTML = theSplit[theSplit.length - 1];
            }
        }else{
            return swal({
              title:`${t("alerts.upload_image_with.png")}`,
              icon:"warning",
              button:`${t("alerts.ok")}`
              })
          }
        }else{
        props.fileUpload(e.target.files[0])
        let a = document.getElementById('files');
        let b = document.getElementById('fileLabel')
        if (a.value == "") {
          b.innerHTML = "Choose file";
        } else {
          let theSplit = a.value.split('\\');
          b.innerHTML = theSplit[theSplit.length - 1];
        }
    }
      };
    switch (props.elementType ) {
        case('input'):
        (props.id == 'password') && props.setPassVal(props.value);
        (props.id == 'capacity')  && Object.keys(props.tableList).length > 0 && props.setCapacity(props.value);
        (props.id == 'qty')  && Object.keys(props.tableList).length > 0 && props.setQty(props.value);
        (props.id == 'Primary - Gift Box Quantity')  && Object.keys(props.tableList).length > 0 && props.setQuantity(props.value);
            inputElement =
                <div>
                    {(props.id == 'confirm_password') ? 
                    <div>
                    <input 
                    className="form-control"
                    {...props.elementConfig}
                    value={props.value}
                    onChange={props.changed}/>
                    <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, `required|in:${props.passVal}`, {messages: {in: `${t('password_match')}`}}) : null}</span>
                    </div> 
                    :
                            (props.id == 'po_number') ?
                    <div>
                        <input 
                        className="form-control"
                        {...props.elementConfig}
                        value={props.value}
                        disabled={props.readonly ? true : false}
                        onChange={props.changed}/>
                         <span>{(props.isValidate.required === true) && props.validater.message(props.id, props.value, ['required',{regex: /^[^\s]+$/}],{messages:{regex:"The po number doesn't contain spaces"}})}</span>
                    </div>
                    :
                     <div>
                        {((props.id == 'qty' || props.id == 'capacity' || props.id == 'Primary - Gift Box Quantity'|| props.id === 'Quantity' || props.id === 'weight'
                        )  && Object.keys(props.tableList).length !== 0) ? 
                        <div>
                             {(props.capacity 
                              || props.level || props.qty || props.material
                              || props.toDate) &&
                              (props.id == 'capacity' || props.id == 'qty' || props.id === 'Quantity'
                              ) ?
                               <span>
                               <input 
                               className="form-control"
                               {...props.elementConfig}
                               accept=".png"
                               value={props.value}
                               onChange={props.changed}/>
                               <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
                              </span>
                             :
                             <input 
                             className="form-control"
                             {...props.elementConfig}
                             accept=".png"
                             value={props.value}
                             onChange={props.changed}/>}
                        </div>
                        :
                        (props.visible && props.id === 'part_number') ?  
                             <span>
                             <input style ={{marginTop : "7px"}}  
                             className="form-control"
                             {...props.elementConfig}
                             accept=".png"
                             value={props.value}
                             readOnly={props.elementConfig.readonly ? true : false}
                             onChange={props.changed}/>
                             <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
                            </span>
                            :
                            <span>
                             <input 
                             className="form-control"
                             {...props.elementConfig}
                             accept=".png"
                             value={props.value}
                             readOnly={props.elementConfig.hasOwnProperty('readonly') ? props.elementConfig.readonly ? true : false : props?.readonly}
                             onChange={props.changed}/>
                             <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
                            </span>
                    }
                    </div>
        }
                </div>;
                break;
        case('file'):
        inputElement =
        <div>
            {(props.titlePreFix == `${t('edit')}`) ?
                <div>
                    {(props.imagePath !== undefined) ?
                        <div>
                            <img src={props.tempImg ? props.tempImg : props.imagePath.props.children.props.src} alt="no img" width="50" height="50" />
                            {props.wizardData && (<h6 className='editImage'>{props.wizardData.productsDetail.data.data1.imgurl}</h6>)}
                            <input
                                style={{ color: props.wizardData.productsDetail.data.data1.imgurl ? 'rgba(0,0,0,0)' : 'black' }}
                                {...props.elementConfig}
                                onChange={props.changed}
                            />
                        </div>
                        :
                        <div>
                            {props.tempImg !== undefined ?
                                <img src={(props.tempImg)} alt="no img" width="50" height="50" />
                                : ''}
                            <input
                                //className="form-control"
                                {...props.elementConfig}
                                onChange={props.changed}
                            //value={props.tempImg}
                            /></div>

                    }
                </div>
                :
                i18n.language === "chi" ?
                    <>
                        <label for="files" className="btn btn-outline-primary btn-rounded waves-effect"> {`${t("choose_file")}`} </label>
                        <input
                            type="file"
                            style={{ display: "none" }}
                            id="files"
                            onChange={(e) => window.pressed(e)} />
                        <label id="fileLabel">{`${t("no_file_choosen")} `}</label>
                    </>
                    :
                    <div>
                {props.tempImg !== undefined ?
            <img src={(props.tempImg)} alt="no img" width="50" height="50" />
                : ''}
                        {props?.customFile ? '' : 
                        <>
                        <input
                            id="files1"
                            ref={ref}
                            {...props.elementConfig}
                                    onChange={props.changed}
                        //value={props.tempImg}
                                />
                        <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
                        </> }
                    </div>
            }
            {/* <img src={value.image} alt="no img" width="50" height="50" /> */}
            {/* <span style={{borderRadius:20,float:"left"}} className="btn btn-outline-primary btn-rounded waves-effect" onClick={props.uploadFunc}> Upload </span> */}
            </div>;
                break;
        case('anchor'):
            inputElement =<div>
             {(props.template === true) ? " " :
            <span>
             <a
                href={props.value}
                {...props.elementConfig}
            >{`${t('click_download')}`}</a>
            </span>}
            </div>;
                break;
        case('textarea'):
            inputElement = 
                <div>
                    {(props.id == 'template') ?
                        <span>
                            <textarea
                                rows="8"
                                className="form-control"
                                {...props.elementConfig}
                                value={props.value}
                                onChange={props.changed}
                            />
                            <span>{(props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules, { className: props.id }) : null}</span>
                        </span> :
                        (props.id === 'generate')  ?
                        <div>
                            <textarea style={{resize: 'both', maxWidth: '570px', width: '100%', boxSizing: 'border-box'}}
                                rows='2'
                                className="form-control"
                                {...props.elementConfig}
                                value={props.value}
                                onChange={props.changed} />
                            <span>{(!props.disabledOnCheck?.whiteList && props.isValidate.required === false) ? props.validater.message(props.elementConfig.placeholder, props.value, ['required' , {regex:/^(?!.*,).+$/gm}], { messages: { regex: "The Whitelist IP doesn't contain comma" } }) : null}</span>
                        </div>
                        :
                        <span>
                            <textarea
                                rows="2"
                                className="form-control"
                                {...props.elementConfig}
                                value={props.value}
                                onChange={props.changed}
                            />

                            <span>{(props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
                        </span>}
                </div>
            break;
            case('invisible'):
            inputElement =<div>

            </div>
            break;
            case('textareaMoreHeight'):
            inputElement = <div>
                <textarea 
                rows="10"
                className="form-control"
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed}
                />
                
                <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
            </div>
            break;
        case('textareaWithoutMandatory'):
            inputElement = <div>     
            <textarea 
            rows="1"
            className="form-control"
            {...props.elementConfig}
            value={props.value}
            onChange={props.changed}
            />
            <span>{ (props.isValidate.required === false) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
        </div>
        break;
        case('select'):
            (props.id == 'product_type' && props.value == 8005 ) && props.setVisible(false) ;
            (props.id == 'product_type' && props.value != 8005 ) && props.setVisible(true) ;
            (props.id == 'product_type' && props.value == 8001) && props.setShow(false);
            (props.id == 'product_type' && props.value != 8001) && props.setShow(true);
            (props.id == 'product_type' && (props.value == 8001 || props.value == 8005)) && props.setToggle(false);
            (props.id == 'product_type' && (props.value == "" || props.value == 8003)) && props.setToggle(true);
            inputElement = <div> {renderView()} </div>
            break;
        case('selectshowlabel'):
        (props.id == 'level') && Object.keys(props.tableList).length > 0 && props.setLevel(props.value);
        (props.id == 'material') && Object.keys(props.tableList).length > 0 && props.setMaterial(props.value);
        (props.id == 'location') && Object.keys(props.tableList).length > 0 && props.setLocation(props.value);
        (props.id == 'product_group') && Object.keys(props.tableList).length > 0 && props.setProductgroup(props.value);
        (props.id == 'product') && Object.keys(props.tableList).length > 0 && props.setProduct(props.value);
        
        inputElement = <div>
             {((props.id === 'level' || props.id === 'material' || props.id === 'product'
             || props.id === 'location' || props.id === 'product_group')
                 && Object.keys(props.tableList).length !== 0) ?
                 <span>
                 {(props.capacity 
                 || props.level || props.qty || props.material || props.quantity
                 || props.location || props.product || props.productgroup) && 
                 (props.id == 'level' 
                 ||  props.id == 'material' || props.id == 'product' ||
                 props.id == 'location' ||  props.id == 'productgroup') ?
                 <span>
                 <select 
            className="form-control" 
            value={props.value}
            onChange={props.changed}>
            {props.elementConfig.options.map(option => (
                <option key={option.value} value={option.displayValue}> {option.displayValue} </option>
            ))}
            </select>
            <span>{ (props.isValidate.required === true) ? 
            props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : 
            null}</span></span>
                :
                <select 
                    className="form-control" 
                    value={props.value}
                    onChange={props.changed}>
                    {props.elementConfig.options.map(option => (
                        <option key={option.value} value={option.displayValue}> {option.displayValue} </option>
                    ))}
                </select>
                 }</span>
                 :
                 <span>
                      <select 
                 className="form-control" 
                 value={props.value}
                 onChange={props.changed}>
                 {props.elementConfig.options.map(option => (
                     <option key={option.value} value={option.displayValue}> {option.displayValue} </option>
                 ))}
                 </select>
                 <span>{ (props.isValidate.required === true) ? 
                 props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : 
                 null}</span>
                 </span>
                  }
        </div>;
        break;
        case('checkbox'):
        inputElement = <div>
            <input
            className="custom-control-input"
            {...props.elementConfig}
            checked={props.value}
            onChange={props.changed}
            /> 
              <span>{ (props.isValidate.required === true) ? props.validater.message(props.id, props.value, props.isValidate.rules) : null}</span>
        </div>;
        break;
        case('selectshowsearch'):
        (props.id == 'material') && Object.keys(props.tableList).length > 0 && props.setMaterial(props.value);
        (props.id == 'product') && Object.keys(props.tableList).length > 0 && props.setProduct(props.value);
        let array = []
        const someProperty = {...props}
        const defaultVendorBulkDownload = (props.title === "IOT Bulk Download" && props.id === 'vendorId') && !(cookies.get('userRole_name') === 'Super Admin');
        const modifyOptions = props.elementConfig.options.map(obj => {
            if (obj.label) {
                return obj;
            }
            const { displayValue, ...rest } = obj;
            return { ...rest, label: displayValue };
        });
        inputElement = <div>
        {(((props.id === 'material' || props.id == 'product' || props.id == 'transaction') && Object.keys(props.tableList).length === 0) || (props.title === 'PDI' && props.labelName === 'PO Number')) ?
        <span>
        <Select
            placeholder={`${t("search")}...`}
            closeMenuOnSelect={true}
            onChange={props.changed}
            value={props.value}
            options= {modifyOptions}
        />
            <span>{ (props.isValidate.required === true) ? 
                props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) :
                null}
            </span>
        </span>
        :
            <span>
            <Select
            placeholder={`${t("search")}...`}
            closeMenuOnSelect={true}
            onChange={props.changed}
            value={defaultVendorBulkDownload ? props.elementConfig.options[0] : props.value}
            isDisabled={defaultVendorBulkDownload || props.elementConfig.readOnly ? true : false}
            options= {modifyOptions}
            />
            <span>{(someProperty?.labelName === 'Choose PO*' && props?.isValidate.required === true) || (props.hasOwnProperty('tableList') === true && Object.keys(props?.tableList).length === 0 && someProperty?.labelName === 'To location*') || 
            ( props.title === "Support" ? props.isValidate.required === true : props.isValidate.required === true && Object.keys(props?.tableList).length === 0) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) :null}
            </span>
            </span>
            }
         </div>;
        break;
        case('radio'):
        inputElement = <div>
            {((props.value == 'Initiated' || props.value == 1 || props.value == 0) && props.value != 'Approved' && props.value != 'Rejected') ?
            <div>
                
                <span onChange={props.changed}>
                <input type="radio" value="1" name="action"/> Approve 
                <input type="radio" value="0" name="action" style={{marginLeft:"10px"}} /> Reject
                </span>
                <span>{ (props.isValidate.required === true) ? props.validater.message(props.id, props.value, props.isValidate.rules) : null}</span>
            </div>  
            :
            <div>
                <span>
                <input type="radio" disabled value="1" name="action" checked={props.value == 'Approved' ? true: false}/> Approve 
                <input type="radio" disabled value="0" name="action" checked={props.value == 'Rejected' ? true: false} style={{marginLeft:"10px"}} /> Reject
                </span>
            </div>
            }
                     
        </div>;
        break;
        case("switch"):
            inputElement = (
                <> 
                    <CustomSwitch changed={props.changed} checked={props.value} />
                </>
            )
            break;
        case('date'):
            inputElement =<div>
                <input 
                    className="form-control"
                    {...props.elementConfig}
                    value={props.value}
                    max={moment().format("YYYY-MM-DD")}
                    onChange={props.changed}/>
                    <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
            </div>;
        break;
        case('from_date'):
        props.setFromDate(props.value);
            let minDate = null;
            if (props.title === "Dispatch" && (customer_id === "13" || customer_id === "15")) {
                minDate = props.toDate ? moment(props.toDate).subtract(6, 'months').format('YYYY-MM-DD') : undefined
            }
            inputElement =<div>
                <input 
                    className="form-control"
                    {...props.elementConfig}
                    inputProps={{readOnly:true}}
                    value={props.value}
                    min={minDate}
                    max={(props.toDate) ? moment(props.toDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")}
                    onChange={props.changed}/>
                     <span>{ (props.toDate) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) :  (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
                    {/* <span>{ (props.toDate) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span> */}
                    {/* //<span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span> */}
            </div>;
        break;
        case('to_date'):
        props.setToDate(props.value);
        const modifyDate = (dates) => {
            return dates.map(date => {
                return Number(date)
            })
        }
        let maxDate = moment().format("YYYY-MM-DD");
        if(props.fromDate && props.title === "Dispatch" && (customer_id === "13" || customer_id === "15")){
            const today = modifyDate(moment().format("YYYY-MM-DD").split("-"))
            const modifiedFromDate = modifyDate(props.fromDate.split("-"))
            const todayDate = moment(today)
            const selectedFromDate = moment(modifiedFromDate)
            const restult = todayDate.diff(selectedFromDate,"days")
            if(restult >= 180){
                maxDate = moment(props.fromDate).add(6, 'months').format('YYYY-MM-DD')
            }else{
                maxDate = moment().format("YYYY-MM-DD")
            }
        }
        inputElement =<div>
            <span>
            <input
            className="form-control"
            {...props.elementConfig}
            value={props.value}
            inputProps={{readOnly:true}}
            min={ (props.fromDate !== ' ') ? moment(props.fromDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")}
            max={maxDate}
            onChange={props.changed}/>
            <span>{ (props.fromDate) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) :  (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
            </span>
        </div>;
    break;
    case('applicable_from_date'):
      inputElement =<div>
                <input 
                    className="form-control"
                    {...props.elementConfig}
                    value={props.value}
                    inputProps={{readOnly:true}}
                    min={moment().add(1,'days').format("YYYY-MM-DD")}
                    onChange={props.changed}/>
                    <span>{(props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span> 
                    </div>;
        break;
        case('multiselect'):
        inputElement =
        (props.visible && props.id == 'component') ?   ''
          :
        <div> 
            <MultiSelect
                {...props.elementConfig}
                placeholder={`${t("search")}...`}
                options={props.elementConfig.options ? props.elementConfig.options : []} 
                labelledBy="Please select"
                value={props.value}
                onChange={props.changed}
                filterOptions={filterOptions}
               hasSelectAll={(!(props.elementConfig.options) || Object.keys(props.elementConfig.options).length <= 0) ? false : true}
            />
            <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
        </div>;
        break;
        case('maps'):
              inputElement =
              <Map
                google={props.google}
                center={props.center}
                height='200px'
                zoom={12}
                address={props.address}
                city={props.city}
                area={props.area}
                state={props.state}
                lat = {props.lat}
                lan = {props.lan}
                setLat = {props.setLat}
                setLan = {props.setLan}  
                country={props.country}  
                mapPosition={props.mapPosition}
                markerPosition={props.markerPosition}   
                setAddress={props.setAddress}
                setCity={props.setCity}
                setArea={props.setArea}
                setState={props.setState}
                setCountry={props.setCountry}
                setMapPosition={props.setMapPosition}
                setMarkerPosition={props.setMarkerPosition}   
              />                                                                                                                    
        break;
        default:
            inputElement = 
            <>
            <input 
                className="form-control"
                value={props.value}
                {...props.elementConfig}
                onChange={props.changed} />
                <span>{(props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
                </>
    }

    return(
        props.visible && (props.id == 'component') ?
        '':
        (props.show === false && props.id === "components") ?
        <div style={{marginTop :"-6em"}} >
        <label className="Label" > { props.labelName } </label>
        {inputElement}
        </div>
        :
        props.toggle && (props.id == 'component_type') ? " "
        :(props.id === "pairing") ?
        <div style={{marginTop :"-83px"}}>
        <label className="Label" > { props.labelName } </label>
        {inputElement}
        </div>
        :
        props.show && (props.id == 'components') ?
        '':
        <div className={props.labelName === "Activate SAP" && "switch-label-container"} >
            <label className={props.labelName === "Activate SAP" ? "switch-label" : "Label"} > { t( props.labelName) } </label>
            {inputElement}
        </div>
    )
}

export default forwardRef(InputField);
 